import React from 'react';
import { Card, CardContent } from '../../../ui/card';
import { StatRowBlock as StatRowBlockType } from '../../../../types/report-builder';

interface Props {
  block: StatRowBlockType;
}

const StatRowBlock: React.FC<Props> = ({ block }) => {
  return (
    <div className="my-6 grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
      {block.stats.map((stat, i) => (
        <Card key={i} className="border-border/70 bg-card shadow-[var(--shadow-card)]">
          <CardContent className="space-y-1 py-4">
            <p className="text-2xl font-bold tabular-nums text-foreground">{stat.value}</p>
            <p className="text-sm font-medium text-muted-foreground">{stat.label}</p>
            {stat.sublabel && (
              <p className="text-xs text-muted-foreground">{stat.sublabel}</p>
            )}
            {stat.trend && stat.trend !== 'neutral' && (
              <span
                className={`text-xs font-medium inline-flex items-center gap-1 ${
                  stat.trend === 'up' ? 'text-[var(--go-teal)]' : 'text-[var(--go-bittersweet)]'
                }`}
              >
                {stat.trend === 'up' ? '\u2191' : '\u2193'}
                {stat.trend === 'up' ? 'Up' : 'Down'}
              </span>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default StatRowBlock;
